const shopDomain = Shopify.shop;

function updateProgressBar(percentage) {
  const progressBar = document.getElementById('profile-progress');
  const percentageText = document.getElementById('progress-percentage');
  const completeMessage = document.getElementById('profile-complete-message');
  
  if (progressBar && percentageText && completeMessage) {
    progressBar.style.width = `${percentage}%`;
    percentageText.textContent = `${percentage}%`;
    
    if (percentage === 100) {
      completeMessage.style.display = 'block';
      percentageText.style.display = 'none';
    } else {
      completeMessage.style.display = 'none';
      percentageText.style.display = 'inline';
    }
    
    progressBar.style.backgroundColor = 
      percentage < 30 ? '#ff5252' :
      percentage < 70 ? '#ffc107' :
      percentage < 100 ? '#4CAF50' :
      '#2E7D32';

    if (percentage === 100) {
      progressBar.classList.add('completed-pulse');
      setTimeout(() => progressBar.classList.remove('completed-pulse'), 1000);
    }
  }
}

function calculateProfileProgress() {
  const basicFields = [
      'nombre', 'apellido', 'email', 'fecha_nacimiento', 'celular', 'cedula', 'genero'
  ];
  
  const cardSections = [
      'household', 'wellness', 'health_conditions', 'motivation', 'diet'
  ];
  
  let completedBasicFields = 0;
  let completedCardSections = 0;

  basicFields.forEach(field => {
      if (field === 'genero') {
          if (document.querySelector('input[name="genero"]:checked')) {
              completedBasicFields++;
          }
      } else {
          const value = document.getElementById(field)?.value;
          if (value && value.trim() !== '') completedBasicFields++;
      }
  });

  cardSections.forEach(section => {
      const inputs = document.querySelectorAll(`input[name="${section}"]:checked`);
      
      if (section === 'health_conditions') {
          if (inputs.length > 0 && inputs.length <= 3) {
              completedCardSections++;
          }
      } else {
          if (inputs.length > 0) {
              completedCardSections++;
          }
      }
  });

  const totalSections = basicFields.length + cardSections.length;
  const completedSections = completedBasicFields + completedCardSections;
  const percentage = Math.round((completedSections / totalSections) * 100);
  
  updateProgressBar(percentage);
  
  return percentage;
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".button-option").forEach(button => {
      button.addEventListener("click", function (event) {
        const checkbox = this.querySelector("input[type='checkbox']");
        const radio = this.querySelector("input[type='radio']");
  
        if (checkbox) {
          if (event.target !== checkbox) {
            checkbox.checked = !checkbox.checked;
          }
          this.classList.toggle("selected", checkbox.checked);
          
          calculateProfileProgress();
        }
  
        if (radio) {
          radio.checked = true;
          
          this.closest('.button-group').querySelectorAll('.button-option').forEach(otherButton => {
            otherButton.classList.remove("selected");
          });
          this.classList.add("selected");
          
          calculateProfileProgress();
        }
      });
    });


    function validateForm() {
      const requiredFields = [
        'nombre', 'apellido', 'email', 
        'celular', 'cedula', 'fecha_nacimiento'
      ];
      
      const basicFieldsValid = requiredFields.every(field => {
        const input = document.getElementById(field);
        return input && input.value.trim() !== '';
      });

      const radioGroups = ['genero', 'motivation', 'diet'];
      const checkboxGroups = ['household', 'wellness', 'health_conditions'];

      const radioGroupsValid = radioGroups.every(group => 
        document.querySelector(`input[name="${group}"]:checked`)
      );

      const checkboxGroupsValid = checkboxGroups.map(group => {
        const selected = document.querySelectorAll(`input[name="${group}"]:checked`);
        return selected.length > 0 && 
              (group !== 'health_conditions' || selected.length <= 3);
      }).every(Boolean);

      return basicFieldsValid && radioGroupsValid && checkboxGroupsValid;
    }

    function collectFormData() {
      const formData = {
        action: "crear_usuario",
        shop: shopDomain,
        datosPersonales: {
          nombre: document.getElementById('nombre').value,
          apellido: document.getElementById('apellido').value,
          email: document.getElementById('email').value,
          fechaNacimiento: document.getElementById('fecha_nacimiento').value,
          celular: document.getElementById('celular').value,
          cedula: document.getElementById('cedula').value,
          genero: document.querySelector('input[name="genero"]:checked')?.value || null
        },
        'Who lives in your household?': Array.from(document.querySelectorAll('input[name="household"]:checked')).map(input => input.value),
        "Im interested in Savvy because I want to support the well-being of:": Array.from(document.querySelectorAll('input[name="wellness"]:checked')).map(input => input.value),
        'What health conditions would you like to improve?': Array.from(document.querySelectorAll('input[name="health_conditions"]:checked')).map(input => input.value),
        'Select the phrase that you identify with the most:': document.querySelector('input[name="motivation"]:checked')?.value || null,
        'Do you follow a specific diet?': document.querySelector('input[name="diet"]:checked')?.value || null
      };
      console.log('Collected form data:', formData);
      
      return formData;
    }

    async function saveProfileData(formData) {
      const maxRetries = 3;
      let retryCount = 0;

      while (retryCount < maxRetries) {
        try {
          const response = await fetch("https://n6bvw5g5mcbxerodytgfde7n7y0grxdg.lambda-url.us-east-2.on.aws/", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData)
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          return await response.json();

        } catch (error) {
          console.error(`Save attempt ${retryCount + 1} failed:`, error);
          retryCount++;
          
          await new Promise(resolve => setTimeout(resolve, 1000 * Math.pow(2, retryCount)));
        }
      }

      throw new Error('Failed to save profile after multiple attempts');
    }

    async function updateShopifyCustomerData(shopifyData) {
      const apiUrl = "https://wtjcv2n52ymqasgisp4tfwcp6e0hkomc.lambda-url.us-east-2.on.aws/"; 

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(shopifyData)
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(`Error al actualizar en Shopify: ${errorData.message || response.statusText}`);
        }

        return await response.json();

      } catch (error) {
        console.error('Error en la llamada a updateShopifyCustomerData:', error);
        // Re-lanzamos el error para que la función que llama (handleProfileSave) sepa que algo falló.
        throw error;
      }
    }

    function showValidationErrors() {
      ['error-personal', 'error-hogar', 'error-bienestar', 'error-condiciones', 'error-condiciones-tres', 'error-motivacion', 'error-dieta']
        .forEach(id => {
          const errorEl = document.getElementById(id);
          if (errorEl) errorEl.style.display = 'none';
        });

      const requiredFields = [
        'nombre', 'apellido', 'email', 
        'celular', 'cedula', 'fecha_nacimiento'
      ];
      
      const basicFieldsValid = requiredFields.every(field => {
        const input = document.getElementById(field);
        return input && input.value.trim() !== '';
      });

      if(!basicFieldsValid){
        document.getElementById('error-personal').style.display = 'block';
      }

      const radioBtnGroups = [
        { name: 'genero', errorId: 'error-personal' },
        { name: 'motivation', errorId: 'error-motivacion' },
        { name: 'diet', errorId: 'error-dieta' }
      ];

      radioBtnGroups.forEach(group => {
        const radioSelected = document.querySelector(`input[name="${group.name}"]:checked`);
        const error = document.getElementById(group.errorId);

        if(!radioSelected){
          error.style.display = 'block';
        }
      });

      const checkboxGroups = [
        { name: 'household', errorId: 'error-hogar' },
        { name: 'wellness', errorId: 'error-bienestar' },
        { name: 'health_conditions', errorId: 'error-condiciones' }
      ];

      checkboxGroups.forEach(group => {
        const selected = document.querySelectorAll(`input[name="${group.name}"]:checked`);
        const errorEl = document.getElementById(group.errorId);
        
        if (selected.length === 0 && errorEl) {
          errorEl.style.display = 'block';
        }
      });

      const healthConditions = document.querySelectorAll('input[name="health_conditions"]:checked');
      const healthConditionsErrorThree = document.getElementById('error-condiciones-tres');
      
      if (healthConditions.length > 3 && healthConditionsErrorThree) {
        healthConditionsErrorThree.style.display = 'block';
      }
    }

    function disableEditMode() {
      const inputs = document.querySelectorAll('input, textarea, select');
      const buttons = document.querySelectorAll('button.button-option');
      const editButtons = document.querySelectorAll('.editar-button-perfil');
    
      inputs.forEach(input => {
        input.disabled = true;
      });
    
      buttons.forEach(button => {
        button.disabled = true;
      });
    
      // Restaurar todos los botones a "Editar"
      editButtons.forEach(button => {
        button.setAttribute('data-mode', 'edit');
        button.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="13" height="13">
            <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
          </svg>Edit
        `;
      });
    }    

    function handleCheckboxChange() {
      const checkboxes = document.querySelectorAll("input[type='checkbox'][name='health_conditions']");

      let checkedCount = 0;
      checkboxes.forEach(cb => {
        if (cb.checked) {
          checkedCount++;
        }
      });

      checkboxes.forEach(cb => {
        if (checkedCount >= 3) {
          if (!cb.checked) {
            cb.disabled = true;
            cb.parentElement.disabled = true;
          } else {
            cb.disabled = false;
            cb.parentElement.disabled = false;
          }
        } else {
          cb.disabled = false;
          cb.parentElement.disabled = false;
        }
      });

    }

    window.addEventListener("load", function () {
      const checkboxes = document.querySelectorAll("input[type='checkbox'][name='health_conditions']");
      checkboxes.forEach(checkbox => {
        checkbox.parentElement.addEventListener('click', handleCheckboxChange);
      });
    });

    function enableEditMode() {
      const inputs = document.querySelectorAll('input, textarea, select');
      const buttons = document.querySelectorAll('button.button-option');
      const editButton = document.querySelectorAll('.editar-button-perfil');

      inputs.forEach(input => {
          if (input.id === 'email' || input.id === 'cedula') {
              if (input.value) {
                  input.disabled = true;
              } else {
                  input.disabled = false;
              }
          } else {
              input.disabled = false;
          }
      });

      buttons.forEach(button => {
          button.disabled = false;
      });

      if (editButton) {
          editButton.innerHTML = 'Save';
      }

      handleCheckboxChange();
    }

    async function handleProfileSave(event) {
      event.preventDefault();

      if (!validateForm()) {
        showValidationErrors();
        return;
      }

      try {
        const formData = collectFormData();
        const result = await saveProfileData(formData);
        
        console.log('Server response:', result);

        const customerIdRaw = document.getElementById('customer_id').value;
        const numericCustomerId = customerIdRaw.split('/').pop();

        const shopifyDataPayload = {
          action: "update_cliente",
          customerId: numericCustomerId,
          firstName: document.getElementById('nombre').value,
          lastName: document.getElementById('apellido').value,
          phone: document.getElementById('celular').value
        };

        const shopifyResult = await updateShopifyCustomerData(shopifyDataPayload);
        console.log('Respuesta de actualización de Shopify:', shopifyResult);
        
        disableEditMode();
        calculateProfileProgress();

      } catch (error) {
        console.error("Error al guardar:", error);

        const statusDiv = document.getElementById('form-status'); // Busca o crea este div en tu Liquid
        if (statusDiv) {
          statusDiv.innerHTML = `<p style="color: red; font-weight: bold;">Error: ${error.message}</p>`;
        } else {
          alert(`Error while saving: ${error.message}`);
        }
      }
    }

    const editButtons = document.querySelectorAll('.editar-button-perfil');
    if (editButtons.length > 0) {
      editButtons.forEach(button => {
        button.addEventListener('click', function(event) {
          event.preventDefault();
          const mode = this.getAttribute('data-mode');

          if (mode === 'edit') {
            enableEditMode();

            // Cambiar todos los botones a modo guardar
            editButtons.forEach(btn => {
              btn.setAttribute('data-mode', 'save');
              btn.innerHTML = 'Save';
            });

          } else {
            handleProfileSave(event);
          }
        });
      });
    }



    calculateProfileProgress();
    
    document.querySelectorAll('input').forEach(input => {
      input.addEventListener('input', calculateProfileProgress);
      input.addEventListener('change', calculateProfileProgress);
    });
  });

  document.addEventListener("DOMContentLoaded", async function() {

    const emailInput = document.getElementById("customer_email");

    if (emailInput && emailInput.value) {
        const email = emailInput.value;

        try {
            const response = await fetch("https://n6bvw5g5mcbxerodytgfde7n7y0grxdg.lambda-url.us-east-2.on.aws/get_usuario_completo", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ action: "mostrar_datos_usuario", email })
            });

            if (!response.ok) {
                throw new Error("Error al verificar el email.");
            }

            const userData = await response.json();

            console.log("Datos del usuario desde el front:", userData);

            const nombreInput = document.getElementById("nombre");
            const apellidoInput = document.getElementById("apellido");
            const emailInput = document.getElementById("email"); 
            const fechaNacimientoInput = document.getElementById("fecha_nacimiento");
            const celularInput = document.getElementById("celular");
            const cedulaInput = document.getElementById("cedula");

            nombreInput.value = userData.nombre ?? nombreInput.value;
            apellidoInput.value = userData.apellido ?? apellidoInput.value;
            emailInput.value = userData.email ?? emailInput.value;
            fechaNacimientoInput.value = userData.fecha_nacimiento ?? fechaNacimientoInput.value;
            celularInput.value = userData.celular ?? celularInput.value;
            cedulaInput.value = userData.cedula ?? cedulaInput.value;

            emailInput.disabled = true;  
            cedulaInput.disabled = true;  

            const generoRadios = document.getElementsByName("genero");
            generoRadios.forEach(radio => {
                if (radio.value === userData.genero) {
                    radio.checked = true;
                }
            });

            userData.respuestas["Who lives in your household?"]?.forEach(value => {
                const checkbox = document.querySelector(`input[name="household"][value="${value}"]`);
                if (checkbox) {
                    checkbox.checked = true;
                    const parent = checkbox.parentElement;
                    parent.classList.add("button-option", "selected");
                    checkbox.disabled = true;
                }
            });

            userData.respuestas["Im interested in Savvy because I want to support the well-being of:"]?.forEach(value => {
                const checkbox = document.querySelector(`input[name="wellness"][value="${value}"]`);
                if (checkbox) {
                    checkbox.checked = true;
                    const parent = checkbox.parentElement;
                    parent.classList.add("button-option", "selected");
                    checkbox.disabled = true;
                }
            });

            userData.respuestas["What health conditions would you like to improve?"]?.forEach(value => {
                const checkbox = document.querySelector(`input[name="health_conditions"][value="${value}"]`);
                if (checkbox) {
                    checkbox.checked = true;
                    const parent = checkbox.parentElement;
                    parent.classList.add("button-option", "selected");
                    checkbox.disabled = true;
                }
            });

            const motivationRadios = document.getElementsByName("motivation");
            const selectedMotivation = userData.respuestas["Select the phrase that you identify with the most:"];
            if (selectedMotivation) {
                motivationRadios.forEach(radio => {
                    if (radio.value === selectedMotivation) {
                        radio.checked = true;
                        const parent = radio.parentElement;
                        parent.classList.add("button-option", "selected");
                        radio.disabled = true;                    
                    }
                });
            }

            const dietRadios = document.getElementsByName("diet");
            const selectedDiet = userData.respuestas["Do you follow a specific diet?"];
            if (selectedDiet) {
                dietRadios.forEach(radio => {
                    if (radio.value === selectedDiet) {
                        radio.checked = true;
                        const parent = radio.parentElement;
                        parent.classList.add("button-option", "selected");
                        radio.disabled = true;
                    }
                });
            }

            const totalSections = basicFields.length + cardSections.length;
            const completedSections = completedBasicFields + completedCardSections;
            const percentage = Math.round((completedSections / totalSections) * 100);
            updateProgressBar(percentage);

        } catch (error) {
            console.error("Error al enviar el email:", error);
        }
    } else {
        console.error("El campo de email está vacío o no se encuentra.");
    }
    calculateProfileProgress();
    
    document.querySelectorAll('input, select').forEach(input => {
        input.addEventListener('input', calculateProfileProgress);
        input.addEventListener('change', calculateProfileProgress);
    });

});